// The Stage chrome design language (#163): a warm "paper label" surface shared by
// the floating topbar and the controls bar, so the chrome reads as one crafted
// system over the warm Stage instead of generic white shadcn pills. Flat per
// DESIGN.md (shadow-sm max) — the warmth + the fine hairline carry it, not depth.
// `chrome`/`chrome-line` are warm tokens (index.css + tailwind.config).
export const CHROME_SURFACE =
  "border border-chrome-line/25 bg-chrome/80 shadow-sm backdrop-blur-md supports-[backdrop-filter]:bg-chrome/70";

// The sewn-seam "stitch": a fine dashed line in the chrome hairline tone — the one
// brand motif that ties the chrome to the product (a sewn pillow). Used as the
// divider between the bar's settings and its actions. `orientation` picks the axis.
export function stitchClass(orientation: "vertical" | "horizontal"): string {
  return orientation === "vertical"
    ? "w-0 self-stretch border-l border-dashed border-chrome-line/45"
    : "h-0 w-full border-t border-dashed border-chrome-line/45";
}
